export default __webpack_public_path__ + "static/media/Akhlak-Hossain-Jim-Project-Portfolio-4-480.f7c6dd03.webp";